import { useToast } from '@chakra-ui/react';
import { useEffect } from 'react';

export function usePrivatePageToast({ isPrivate }: { isPrivate: boolean }) {
  const toast = useToast();
  useEffect(() => {
    if (isPrivate) {
      toast({
        title: 'プレビュー',
        description:
          'このページはプレビューです。ユーザーには公開されていません',
        status: 'success',
        isClosable: true,
        variant: 'subtle',
        position: 'top',
        duration: 100000,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPrivate]);
  return null;
}
